// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2cSDz","image":"Header_image__Q575e","name":"Header_name__34Noa","info":"Header_info__11-SR","infoRow":"Header_infoRow__3oZlC"};